import { useEffect, useState } from 'react';
// import ReactQuill, { Quill } from "react-quill";
import { useTranslation } from 'react-i18next';
import store from '../../../../storeClient';
import ConsultasClient from '../../../api/consultas';

const ReactQuill = typeof window === 'object' ? require('react-quill') : () => false;

const ConsultaDetalle = (props) => {
  const { t } = useTranslation();
  const [banner, setBanner] = useState();
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [comentarios, setComentarios] = useState('');
  const { token } = store.getState().applicationState;
  const empresaId = store.getState().applicationState.applicationId;
  const nombreAgencia = store.getState().applicationState.nombre;
  const { paisId } = store.getState().applicationState;
  const emailAgencia = store.getState().applicationState.templateData?.header.emailContacto;
  const [consulta, setConsulta] = useState({
    estadoConsulta: '',
  });
  const handleNombreChange = (event) => {
    setNombre(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleTelefonoChange = (event) => {
    setTelefono(event.target.value);
  };

  const handleComentariosChange = (event) => {
    setComentarios(event.target.value);
  };

  useEffect(() => {
    const rawBanners = JSON.parse(localStorage.getItem('banners'));
    const bannerList = [];
    rawBanners.forEach((item) => {
      item.banner.forEach((banner) => {
        bannerList.push(banner);
      });
    });

    const filteredBanner = bannerList.find((banner) => banner.id === Number(props.match.params.id));
    setBanner(filteredBanner);
  }, []);

  const enviarConsulta = (event) => {
    event.preventDefault();
    const data = {
      nombre,
      email,
      comentarios,
      agenciaId: empresaId,
      nombreAgencia,
      paisId,
      emailAgencia,
      bannerId: banner.id,
      bannerTitle: banner.title,
      bannerDescription: banner.description,
      telefono,
      totalDias: 0,
      totalAdultos: 0,
      totalNinos: 0,
      mes: '',
      year: 0,
      apellido: '',
      destino: '',
      id: 0,
      estado: {
        id: 1,
      },
      tipoConsulta: 'banners',
      banner: {
        id: banner.id,
      },
    };
    ConsultasClient.consultaMarcaBlanca(data, token).then((res) => {
      if (res.status === 201) {
        setConsulta({
          estadoConsulta: 'enviado',
        });
        data.id = res.data.id;
        ConsultasClient.enviarMailConsulta(data, token).then((res) => {
          if (res.status === 201) {
            alert('La consulta se envió correctamente');
          } else {
            alert('La consulta no se pudo enviar');
          }
        });
        resetForm();
      } else {
        setConsulta({
          estadoConsulta: 'error',
        });
        alert('La consulta no se pudo enviar');
      }
    });
  };

  const resetForm = () => {
    setNombre('');
    setEmail('');
    setTelefono('');
    setComentarios('');
  };

  return banner ? (
    <div className='container-consult'>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <h1 className='text-3xl font-bold text-gray-700 mb-2'>{banner.title}</h1>
          <h2 className='text-lg font-bold text-gray-600'>{banner.description}</h2>
        </div>
      </div>
      <div className='col-span-2'>
        <ReactQuill readOnly theme='bubble' value={banner.detalle} />
      </div>
      <form className='container-consult__detalle-form' onSubmit={enviarConsulta}>
        <h2 className='text-lg font-bold consulta-title c mb-2'>{t('requestForm.requestTitle')}</h2>
        <div className='grid grid-cols-12 gap-4 mb-4'>
          <div className='col-span-12 md:col-span-4'>
            <div className='form-group'>
              <div className='clearfix' />
              <span className='block text-gray-700 text-sm font-bold mb-2'>
                {t('requestForm.name')} (*)
              </span>
              <input
                className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                id='nombre'
                maxLength={50}
                name='nombre'
                onChange={handleNombreChange}
                required
                type='text'
                value={nombre}
              />
            </div>
          </div>
          <div className='col-span-12 md:col-span-4'>
            <div className='form-group'>
              <span className='block text-gray-700 text-sm font-bold mb-2'>E-mail (*)</span>
              <input
                className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                id='email'
                maxLength={50}
                name='email'
                onChange={handleEmailChange}
                required
                type='email'
                value={email}
              />
            </div>
          </div>
          <div className='col-span-12 md:col-span-4'>
            <div className='form-group'>
              <span className='block text-gray-700 text-sm font-bold mb-2'>
                {t('requestForm.phone')}
              </span>
              <input
                className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                id='telefono'
                maxLength={50}
                name='telefono'
                onChange={handleTelefonoChange}
                type='number'
                value={telefono}
              />
            </div>
          </div>
        </div>
        <div className='my-2'>
          <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='comentarios'>
            {t('requestForm.message')} (*)
          </label>
          <textarea
            className='h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
            id='comentarios'
            name='comentarios'
            onChange={handleComentariosChange}
            placeholder={t('requestForm.commentsPlaceholder')}
            required
            rows='5'
            value={comentarios}
          />
        </div>
        <div className='flex'>
          <button
            className='ml-auto border border-blue-200 consulta-title transition duration-300 hover:bg-blue-100 font-semibold py-2 px-8 rounded focus:outline-none'
            type='submit'
          >
            {t('requestForm.send')}
          </button>
        </div>
      </form>
    </div>
  ) : (
    <div />
  );
};

export default ConsultaDetalle;
